import { UsageProvider } from "@/constants/terminal/usage-provider"

// Flat-rate plans bill a month, not a request, so a unit's dollar value is the
// plan price spread over the units it includes. A metered provider has no plan
// price: it bills each request in dollars, so its unit is a dollar.
type ProviderPlan = { name: string; unit: string; planName: string } & (
  | { monthlyUsd: number; includedUnits: number }
  | { monthlyUsd: null; includedUnits: null }
)

export const planByUsageProvider = {
  // $275 a month for 30,000 searches (Nathan, 2026-10-21).
  [UsageProvider.SERPAPI]: {
    name: "SerpApi",
    unit: "searches",
    planName: "30k searches",
    monthlyUsd: 275,
    includedUnits: 30_000,
  },
  // 1,000,000 credits for $150 a month (Nathan, 2026-10-04).
  [UsageProvider.SCRAPERAPI]: {
    name: "ScraperAPI",
    unit: "credits",
    planName: "1M credits",
    monthlyUsd: 150,
    includedUnits: 1_000_000,
  },
  [UsageProvider.BROWSERBASE]: {
    name: "Browserbase",
    unit: "minutes",
    planName: "Startup",
    monthlyUsd: 99,
    includedUnits: 30_000,
  },
  // Apify bills each actor run's platform usage in dollars, so a unit is a
  // dollar. The Free plan includes $5 of usage a month (2026-10-06).
  [UsageProvider.APIFY]: {
    name: "Apify",
    unit: "USD",
    planName: "Free",
    monthlyUsd: 5,
    includedUnits: 5,
  },
  // Each Case Locator search page states its fee on the page's receipt.
  [UsageProvider.PACER]: {
    name: "PACER",
    unit: "USD",
    planName: "Billed per search page",
    monthlyUsd: null,
    includedUnits: null,
  },
} satisfies Record<UsageProvider, ProviderPlan>

export const usdPerUnit = (provider: UsageProvider) => {
  const plan: ProviderPlan = planByUsageProvider[provider]
  return plan.monthlyUsd === null ? 1 : plan.monthlyUsd / plan.includedUnits
}

export const DAILY_SPEND_BUDGET_USD = 200
